import { EPreferredScoringLanguage } from 'components/Interviews/ScoreInterview/scoring.context';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import {
  EAvailableLanguageCodes,
  type TAnyClientQuestionType,
  hasKey,
  type TAvailableLanguageCodes,
} from '@hubertai/screening-question-types';

export function usePreferredQuestionLanguage(
  questionId: string,
  question: TAnyClientQuestionType | undefined,
  expectedLanguage: TAvailableLanguageCodes,
  preferredLanguage: EPreferredScoringLanguage,
): {
  questionText: string;
} {
  const [questionText, setQuestionText] = useState<string>('');

  useEffect(() => {
    let _text = '';

    // Skip processing if the connected question is the bonus booster
    if (questionId === 'bonus_booster') {
      return;
    }

    if (!question) {
      toast.error(`usePreferredQuestionLanguage - question is missing ${questionId}`);
      return;
    }

    const text = question.text;

    if (
      !preferredLanguage &&
      question.available_languages.includes(expectedLanguage) &&
      hasKey(text, expectedLanguage) &&
      text[expectedLanguage]
    ) {
      // @ts-ignore
      _text = text[expectedLanguage]?.join(' ');
    } else if (preferredLanguage === EPreferredScoringLanguage.English) {
      if (
        question?.available_languages.includes(EAvailableLanguageCodes.enGB) &&
        hasKey(text, EAvailableLanguageCodes.enGB)
      ) {
        // @ts-ignore
        _text = text[EAvailableLanguageCodes.enGB]?.join(' ');
      } else if (
        question?.available_languages.includes(EAvailableLanguageCodes.enUS) &&
        hasKey(text, EAvailableLanguageCodes.enUS)
      ) {
        // @ts-ignore
        _text = text[EAvailableLanguageCodes.enUS]?.join(' ');
      } else {
        // @ts-ignore
        _text = text[expectedLanguage]?.join(' ');
      }
    } else if (preferredLanguage === EPreferredScoringLanguage.Original) {
      // @ts-ignore
      _text = text[expectedLanguage]?.join(' ');
    } else {
      toast.error(
        `usePreferredQuestionLanguage - Unknown error - preferredLanguage: ${preferredLanguage} ${questionId}.`,
      );
    }

    setQuestionText(_text ?? '');
  }, [preferredLanguage, question]);

  return {
    questionText,
  };
}
